import { Theme } from '@mui/material/styles'
//
import { semantic } from '../tokens/semantic'
import { StarIcon } from './CustomIcons'

// ----------------------------------------------------------------------

export default function Rating(theme: Theme) {
  const tokens = semantic[theme.palette.mode]

  // The stroke is the meaning-bearing layer (3.9:1 on white); it is the fill's
  // own hue darkened, not ink — a near-black outline this heavy dragged the star
  // towards olive. Empty stars keep the same geometry with a sunken fill and a
  // muted stroke, so "4 of 5" reads by shape even for a user who can't see amber.
  //
  // The width is in the icon's 24-unit viewBox, so it scales with the star: right
  // for the 16–28px marks the app draws, a 4px band on a star blown up to 60. Draw
  // stars much larger than this and pin the line with vectorEffect — see the survey
  // form's surveyStarSx.
  const strokeStyle = {
    strokeWidth: 1.7,
    strokeLinejoin: 'round' as const,
    strokeLinecap: 'round' as const,
  }
  // Only the kit's own star, never an icon a consumer passed in.
  const starPath = '& path[data-star]'

  return {
    MuiRating: {
      defaultProps: {
        emptyIcon: <StarIcon />,
        icon: <StarIcon />,
      },
      styleOverrides: {
        root: {
          // Filled stars inherit this, the way MUI's own default does, so a survey
          // setting its own starColor on the Rating still wins.
          color: tokens.star,
          '&.Mui-disabled': {
            opacity: 0.48,
          },
        },
        iconFilled: {
          [starPath]: { stroke: tokens.sigStroke, ...strokeStyle },
        },
        iconEmpty: {
          color: tokens.surface2,
          [starPath]: { stroke: tokens.sigStrokeEmpty, ...strokeStyle },
        },
        sizeSmall: {
          '& svg': {
            width: 20,
            height: 20,
          },
        },
        sizeLarge: {
          '& svg': {
            width: 28,
            height: 28,
          },
        },
      },
    },
  }
}
